import { logger } from '@/utils/logger';

import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import OrganizationInput from './OrganizationInput';
import EmailInput from './EmailInput';

interface SignUpFormProps {
  organizationCode: string;
  setOrganizationCode: (code: string) => void;
  email: string;
  setEmail: (email: string) => void;
  password: string;
  setPassword: (password: string) => void;
  fullName: string;
  setFullName: (name: string) => void;
  isLoading: boolean;
  rememberOrganization: boolean;
  handleRememberOrganization: (checked: boolean) => void;
  rememberEmail: boolean;
  handleRememberEmail: (checked: boolean) => void;
  onSignUp: () => Promise<void>;
  toast: any;
}

const SignUpForm: React.FC<SignUpFormProps> = ({
  organizationCode,
  setOrganizationCode,
  email,
  setEmail,
  password,
  setPassword,
  fullName,
  setFullName,
  isLoading,
  rememberOrganization,
  handleRememberOrganization,
  rememberEmail,
  handleRememberEmail,
  onSignUp,
  toast
}) => {
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      await onSignUp();
    } catch (error: any) {
      logger.error('Sign up error:', error);
      toast({
        title: "Sign up failed",
        description: error.message || "An unexpected error occurred.",
        variant: "destructive"
      });
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <OrganizationInput
        organizationCode={organizationCode}
        setOrganizationCode={setOrganizationCode}
        rememberOrganization={rememberOrganization}
        onRememberChange={handleRememberOrganization}
      />

      <EmailInput
        email={email}
        setEmail={setEmail}
        rememberEmail={rememberEmail}
        onRememberChange={handleRememberEmail}
      />

      <div className="space-y-2">
        <Label htmlFor="fullName">Full Name</Label>
        <Input
          id="fullName"
          type="text"
          value={fullName}
          onChange={(e) => setFullName(e.target.value)}
          placeholder="Enter your full name"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="password">Password</Label>
        <Input
          id="password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          placeholder="Enter your password"
          minLength={6}
        />
      </div>

      <Button
        type="submit"
        className="w-full"
        disabled={isLoading}
      >
        {isLoading ? 'Creating Account...' : 'Sign Up'}
      </Button>
    </form>
  );
};

export default SignUpForm;
